import { useEffect, useState } from "react";
import type { ClipsUtilityProps, EventListTeamInfo, GameClipResponse, User } from "../../../types";
import { PaginationControls } from "ui-kit/src/PaginationControls/PaginationControls"
import "./clips.css"
import { GameClipCard } from "./GameClipCard";
import { ClipsSkeleton } from "../../../../gamePage/components/Skeletons/ClipsSkeleton";
import { ShareClipModal } from "./ShareClipModal";
import { useI18n } from "i18n/context";

interface ClipsProps {
	toastMessage: (type: string, message: string) => void;
	clips: ClipsUtilityProps;
	selectedClip?: GameClipResponse;
	isClipsLoading: boolean;
	isSelectedClipLoading: boolean;
	teamInfo: EventListTeamInfo;
	domainURL: string;
	isAdmin?: boolean;
	showShareButton?: boolean;
}

export function Clips({ isAdmin, showShareButton = true, domainURL, teamInfo, clips, selectedClip, isClipsLoading, isSelectedClipLoading, toastMessage }: ClipsProps) {
	const [showClip, setShowClip] = useState(false);
	const [selectedClipId, setSelectedClipId] = useState(0);
	const [shareClipData, setShareClipData] = useState<{ id?: number; show: boolean } | null>(null);
	// biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
	useEffect(() => {
		clips.selectClip(selectedClipId)
	}, [selectedClipId])

	const handleShareClip = (id: number) => {
		setShareClipData({ id: id, show: true });
	};

	const closeShareModal = () => {
		setShareClipData({ id: 0, show: false });
	}

	return (
		<div className="gameClips-container">
			{isClipsLoading ?
				<ClipsSkeleton />
				:
				<>
					{clips.data?.items?.map(clip =>
						<div key={clip.id}>
						<GameClipCard
							isAdmin={isAdmin}
							showShareButton={showShareButton}
							teamInfo={teamInfo}
							selectedClipId={selectedClipId}
							isLoading={isSelectedClipLoading}
							setShowClip={(show: boolean) => setShowClip(show)}
							showClip={showClip}
							clip={clip}
							selectClip={(id: number) => setSelectedClipId(id)}
							onEdit={clips.edit}
							onDelete={clips.delete}
							selectedClip={selectedClip}
							handleShareClip={handleShareClip}
						/>
							{shareClipData?.id === clip.id && <ShareClipModal toastMessage={toastMessage} domainURL={domainURL} generateShareLink={clips.generateShareLink} newShareSlug={clips.newShareSlug} clip={clip} show={shareClipData?.show} onClose={closeShareModal} />}
						</div>
					)}
					<PaginationControls currentPage={clips.pagination.page} totalPages={clips.data?.pages ?? 0} changePage={(page) => { clips.onPaginationChange({ ...clips.pagination, page: page }) }} />
				</>
			}
		</div>
	)
}
